export default function DashboardStats({ signups }) {
  const total = signups.length;

  const newLeads = signups.filter(
    (s) => (s.status || "New") === "New"
  ).length;

  const contacted = signups.filter(
    (s) => s.status === "Contacted"
  ).length;

  const converted = signups.filter(
    (s) => s.status === "Converted"
  ).length;

  const cards = [
    {
      title: "Total",
      value: total,
    },
    {
      title: "New",
      value: newLeads,
    },
    {
      title: "Contacted",
      value: contacted,
    },
    {
      title: "Converted",
      value: converted,
    },
  ];

  return (
    <div className="grid md:grid-cols-4 gap-5 mb-8">
      {cards.map((card) => (
        <div
          key={card.title}
          className="bg-white rounded-3xl border border-sage-100 p-6 shadow-soft"
        >
          <p className="text-sm text-ink-muted">
            {card.title}
          </p>

          <h2 className="font-serif text-4xl text-ink mt-3">
            {card.value}
          </h2>
        </div>
      ))}
    </div>
  );
}